<div class="field-group">
  <label class="field-label" [for]="inputId">{{ label }}</label>

  <div class="input-wrapper" [class.input-wrapper--error]="control.invalid && control.touched">
    <span class="input-icon">
      <div class="icon-mask" [style.--icon-url]="'url(assets/icons/email.svg)'"></div>
    </span>
    <input
      [id]="inputId"
      class="input-field"
      type="text"
      [placeholder]="placeholder"
      autocomplete="username"
      [formControl]="control"
      (blur)="onBlur()"
    />
  </div>

  @if (control.hasError('required') && control.touched) {
    <span class="field-error">Please enter your email.</span>
  }
  @if (control.hasError('invalidEmail') && control.touched) {
    <span class="field-error">Please enter a valid email address.</span>
  }
</div>
